<template>
<div>
  <div v-if="showAllVoicemails && numMailboxes>0">
    <v-card flat>
      <v-list>
        <v-list-item v-for="mailbox in this.Mailboxes" :key = "mailbox.ast_voicemail_id" href="#" class="list-group-item" @click="openVoicemailSettings(mailbox);">
          {{mailbox.mailbox}} {{mailbox.fullname}}
        </v-list-item>
      </v-list>
    </v-card>
  </div>
  <div v-if="!showAllVoicemails">
    <app-voicemail-mailbox-settings
      :voicemail="selectedMailbox"
      :click2call="click2call"
      @closeVoicemail="showAllVoicemails=true">
    </app-voicemail-mailbox-settings>
  </div>
</div>
</template>

<script >
import VoicemailMailboxSettings from '../components/voicemail-mailbox-settings.vue';
export default {
  data: function() {
    return {
      Mailboxes: [],
      showAllVoicemails: true,
      selectedMailbox: {},
    }
  },
  props: {
    click2call: String,
  },
  computed: {
    numMailboxes: function () {
      if (this.Mailboxes) {
        return this.Mailboxes.length;
      } else {
        return 0;
      }     
    }
  },
  methods: {
    getVoicemails: function() {
      this.$http.get(
        global.apiurl + "/voicemail-settings&" +
          "token=" + encodeURIComponent(this.click2call)
      ).then(response => {
        if (response.body) {
          if (response.body.Voicemails) {
            this.Mailboxes = response.body.Voicemails;
          }
        }
      });
    },
    
    openVoicemailSettings: function(mailbox) {
      this.selectedMailbox = mailbox;
      this.showAllVoicemails = !this.showAllVoicemails;
    },
  },
  mounted() {
    this.getVoicemails();
  },
  components: {
    'app-voicemail-mailbox-settings': VoicemailMailboxSettings
  },
}
</script>
<style scoped>
div {
  width:100%;
}
</style>